<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import BrowserPreview from "@/views/dataAnalysis/components/BrowserPreview.vue";

export default {
  name: "dataAnalysisDetail",
  components: { BrowserPreview, breadcrumbs },
  data() {
    return {
      form: {},
      ossUrl: "mr-futrue.oss-cn-shenzhen.aliyuncs.com",
      websiteUrl: "pip.mr-future.com"
    };
  },
  created() {
    if (this.$route.query.detail) {
      try {
        const detail = JSON.parse(this.$route.query.detail);
        Object.assign(this.form, detail);
      } catch (e) {}
      console.log(this.form);
    }
  },
  computed: {
    url() {
      return this.replaceOssUrl(this.form.url, this.ossUrl, this.websiteUrl);
    }
  },
  methods: {
    replaceOssUrl(url, sourceDomain, targetDomain) {
      // 验证输入
      if (!url || !sourceDomain || !targetDomain) {
        return "";
      }

      // 转义 sourceDomain 中的特殊正则字符（如 . - 等）
      const escapeRegExp = str => str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

      // 构建动态正则：匹配 https://<sourceDomain>/<path>
      const regex = new RegExp(`^https://${escapeRegExp(sourceDomain)}/(.+)$`);

      const match = url.match(regex);
      if (match) {
        return `https://${targetDomain}/${match[1]}`;
      }

      return ""; // 未匹配返回空字符串
    }
  }
};
</script>

<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.back()"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <div class="pd-15 bg-white">
      <div class="info">
        <div class="list">
          <div class="item">
            <div class="lable">所属分区：</div>
            <div class="value">{{ form.companyName }}</div>
          </div>
          <div class="item">
            <div class="lable">会话ID：</div>
            <div class="value">{{ form.sessionId }}</div>
          </div>
          <div class="item">
            <div class="lable">生成时间:</div>
            <div class="value">{{ form.createTime }}</div>
          </div>
        </div>
      </div>
      <BrowserPreview class="mgt-15" :src="url" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.info {
  width: 100%;
  .list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .item {
      display: flex;
      align-items: center;
      .lable {
        font-weight: bold;
        font-size: 20px;
      }
      .value {
        margin-left: 10px;
        font-size: 18px;
      }
    }
  }
}
</style>
